import '@babel/polyfill';
import Vuex from 'vuex';
import { shallowMount, createLocalVue } from "@vue/test-utils";
import WelcomeNextShipment from './WelcomeNextShipment';
const MockDate = require('mockdate');
import { deepCopyObj } from '../../../../../utilities/mrVueUtils';

const localVue = createLocalVue();
localVue.use(Vuex);
localVue.use(require('vue-moment'));

let updateRefillItemQtyMock = jest.fn();
let removeRefillItemMock = jest.fn();
let removeSubAttachmentMock = jest.fn();
let updateSubAttachmentQtyMock = jest.fn();
let getNextShipmentMock = jest.fn();
let initRefillCartMock = jest.fn();
let loadRefillCartMock = jest.fn();

let nextSubShipment = [{
  id: 1234,
  frequency: 4,
  attachments: [{
    id: 4332,
    product_id: 177
  }],
  inactive: false,
  product_info: {
    id: 15
  }
}];

let refillCart = {
  subscriptionsInCart: [],
  addonsInCart: [],
  nextShipment: {
    sub_id: 4567
  }
};

const storeObj = {
  modules: {
    refillCart: {
      namespaced: true,
      state: {
        refillCart
      },
      actions: {
        initRefillCart: initRefillCartMock,
        loadRefillCart: loadRefillCartMock,
        updateRefillItemQty: updateRefillItemQtyMock,
        removeRefillItem: removeRefillItemMock
      }
    },

    subscriptions: {
      namespaced: true,
      getters: {
        nextSubShipment: () => nextSubShipment
      },
      actions: {
        removeSubAttachment: removeSubAttachmentMock,
        updateSubAttachmentQty: updateSubAttachmentQtyMock,
        getNextShipment: getNextShipmentMock
      }
    }
  }
};

const createWrapper = (storeObj) => {
  let store = new Vuex.Store(storeObj);
  return shallowMount(WelcomeNextShipment, {
    localVue,
    store
  });
};

describe('WelcomeNextShipment', () => {
  test('general snapshot', () => {
    let wrapper = createWrapper(storeObj);
    expect(wrapper.html()).toMatchSnapshot();
  });

  describe('computed', () => {

    describe('nextShipmentTotal', () => {
      test('return displaySubtotal from refillCart.totals', () => {
        let localState = {
          refillCart: {
            totals: {
              displaySubtotal: 39,
              discount: 0
            }
          }
        };

        let res = WelcomeNextShipment.computed.nextShipmentTotal.call(localState);
        expect(res).toBe(39);
      });

      test('return displaySubtotal + discount from refillCart.totals', () => {
        let localState = {
          refillCart: {
            totals: {
              displaySubtotal: 39,
              discount: -15
            }
          }
        };

        let res = WelcomeNextShipment.computed.nextShipmentTotal.call(localState);
        expect(res).toBe(24);
      });
    });

    describe('preparing', () => {
      beforeEach(() => {
        MockDate.set('2019-07-01');
      });

      test('return false when nextShipment does not exist', () => {
        let localState = {
          refillCart: {}
        };
        let res = WelcomeNextShipment.computed.preparing.call(localState);
        expect(res).toBe(false);
      });

      test('return false when nextShipment.next is more than 10 days from today', () => {
        let localNextShipment = {
          id: 123,
          next: '2019-07-11'
        };

        let localStore = deepCopyObj(storeObj);
        localStore.modules.refillCart.state.refillCart.nextShipment = localNextShipment;
        const wrapper = createWrapper(localStore);
        expect(wrapper.vm.preparing).toBe(false);
      });

      test('return true when nextShipment.next is less than 10 days from today', () => {
        let localNextShipment = {
          id: 123,
          next: '2019-07-09'
        };

        let localStore = deepCopyObj(storeObj);
        localStore.modules.refillCart.state.refillCart.nextShipment = localNextShipment;
        const wrapper = createWrapper(localStore);
        expect(wrapper.vm.preparing).toBe(true);
      });
    });

    describe('subscriptionTitle', () => {
      test('return "Your subscriptions" when nextShipment contains more than one sub', () => {
        let localState = {
          refillCart: {
            subscriptionsInCart: [{
              id: 123,
              subscription: 4
            }, {
              id: 234,
              subscription: 6
            }]
          }
        };
        let res = WelcomeNextShipment.computed.subscriptionTitle.call(localState);
        expect(res).toEqual('Your subscriptions');
      });

      test('return "Your subscription" when nextShipment contains one sub', () => {
        let localState = {
          refillCart: {
            subscriptionsInCart: [{
              id: 123,
              subscription: 4
            }]
          }
        };
        let res = WelcomeNextShipment.computed.subscriptionTitle.call(localState);
        expect(res).toEqual('Your subscription');
      });
    });
  });

  describe('methods', () => {
    afterEach(() => {
      updateRefillItemQtyMock.mockClear();
      removeRefillItemMock.mockClear();
      removeSubAttachmentMock.mockClear();
      updateSubAttachmentQtyMock.mockClear();
      getNextShipmentMock.mockClear();
    });

    describe('onQtyChange', () => {
      test('abort call if qty not passed in', () => {
        const wrapper = createWrapper(storeObj);
        let qty;
        let item = {
          id: 143,
        };
        wrapper.vm.onQtyChange(item, qty);

        expect(updateRefillItemQtyMock).toHaveBeenCalledTimes(0);
        expect(updateSubAttachmentQtyMock).toHaveBeenCalledTimes(0);
      });

      test('call updateRefillItemQty when item is not sub attachment', () => {
        const wrapper = createWrapper(storeObj);
        let qty = 1;
        let item = {
          id: 143,
          index: 2,
        };

        let expectedPayload = {
          qty,
          index: item.index,
          subscriptionId: 4567,
          product_id: 143,
          ctaSource: 'rcdWelcomeNextShipment'
        };

        wrapper.vm.onQtyChange(item, qty);

        expect(updateRefillItemQtyMock).toHaveBeenCalledTimes(1);
        expect(updateRefillItemQtyMock).toHaveBeenCalledWith(expect.any(Object), expectedPayload, undefined);
        expect(updateSubAttachmentQtyMock).toHaveBeenCalledTimes(0);
      });

      test('call updateSubAttachmentQty when item does not have own property of index', () => {
        const wrapper = createWrapper(storeObj);
        let qty = 2;
        let item = {
          id: 143,
          subscription_id: 556,
          isAttachment: true
        };

        let expectedPayload = {
          sub_id: item.subscription_id,
          qty,
          attachment_id: item.id
        };

        wrapper.vm.onQtyChange(item, qty);

        expect(updateRefillItemQtyMock).toHaveBeenCalledTimes(0);
        expect(updateSubAttachmentQtyMock).toHaveBeenCalledTimes(1);
        expect(updateSubAttachmentQtyMock).toHaveBeenCalledWith(expect.any(Object), expectedPayload, undefined);
      });
    });

    describe('removeItem', () => {
      test('call removeRefillItem when item is not sub attachment', () => {
        const wrapper = createWrapper(storeObj);
        let item = {
          id: 23,
          index: 1
        };
        let expectedPayload = {
          subscriptionId: 4567,
          index: item.index,
          product_id: 23,
          ctaSource: 'rcdWelcomeNextShipment'
        };

        wrapper.vm.removeItem(item);
        expect(removeRefillItemMock).toHaveBeenCalledTimes(1);
        expect(removeRefillItemMock).toHaveBeenCalledWith(expect.any(Object), expectedPayload, undefined);
        expect(removeSubAttachmentMock).toHaveBeenCalledTimes(0);
      });

      test('call removeSubAttachment when item does not have own property isAttachment', () => {
        const wrapper = createWrapper(storeObj);
        let item = {
          id: 23,
          subscription_id: 4567,
          isAttachment: true
        };

        let expectedPayload = {
          sub_id: item.subscription_id,
          attachment_id: item.id
        };

        wrapper.vm.removeItem(item);
        expect(removeRefillItemMock).toHaveBeenCalledTimes(0);
        expect(removeSubAttachmentMock).toHaveBeenCalledTimes(1);
        expect(removeSubAttachmentMock).toHaveBeenCalledWith(expect.any(Object), expectedPayload, undefined);
      });
    });
  });
});
